import { Component, OnInit } from '@angular/core';
import { Button } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { Message, PrimeTemplate } from 'primeng/api';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { MailingService } from '../../../services/mailing.service';
import { tapResponse } from '@ngrx/operators';

@Component({
  selector: 'app-forget-password',
  standalone: true,
  imports: [
    Button,
    CardModule,
    InputTextModule,
    MessagesModule,
    PrimeTemplate,
    ReactiveFormsModule,
  ],
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss',
})
export class ForgetPasswordComponent implements OnInit {
  forgetForm: FormGroup = new FormGroup({});
  submitted = false;

  loading = false;
  sent = false;
  messages: Message[] = [];

  constructor(
    private mailingService: MailingService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {}

  /**
   * Initializes the component and sets up the form group for the forget password functionality.
   * This method is called once when the component is initialized.
   *
   * @return {void} No return value.
   */
  ngOnInit(): void {
    this.forgetForm = this.formBuilder.group({
      username: ['', Validators.required],
    });
  }

  /**
   * Handles the form submission for the "Forgot Password" feature.
   * Sends an email to the user with a link to reset the password.
   * Displays informational or error messages based on the outcome
   * of the email sending process.
   *
   * @return {void} No return value.
   */
  onSubmit(): void {
    this.submitted = true;
    const { username } = this.forgetForm.value;

    this.mailingService
      .sendForgotPasswordMail(username)
      .pipe(
        tapResponse({
          next: response => {
            console.log('NEXT:', response);
            this.sent = true;
            this.messages = [
              {
                severity: 'info',
                detail:
                  'Checken Sie Ihr E-Mail-Konto. Ein Link um Ihr Passwort zurückzusetzen wird Ihnen zugesendet.',
              },
            ];
            setTimeout(() => {
              //this.router.navigate(['/login']);
            }, 5000);
          },
          error: error => {
            console.log('error', error);
            this.sent = true;
            this.messages = [
              {
                severity: 'error',
                detail:
                  'Ihre Anfrage konnte nicht durchgeführt werden. Bitte versuchen Sie es erneut.',
              },
            ];
            setTimeout(() => {
              //this.router.navigate(['/login']);
            }, 5000);
          },
        })
      )
      .subscribe();
  }
}
